/** @file unitSquare: four corners of an axis-aligned square in the plane of two unit-frame axes. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** Corners `(u0, v0) (u1, v0) (u1, v1) (u0, v1)` on axes `u` and `v`, offset by `at` (default the origin). */
export function unitSquare(u: number, v: number, us: readonly [number, number], vs: readonly [number, number], at: Vec3 = [0, 0, 0]): Vec3[] {
  const corner = (a: number, b: number): Vec3 => {
    const p: [number, number, number] = [at[0], at[1], at[2]];
    p[u] = (p[u] ?? 0) + a;
    p[v] = (p[v] ?? 0) + b;
    return p;
  };
  return [corner(us[0], vs[0]), corner(us[1], vs[0]), corner(us[1], vs[1]), corner(us[0], vs[1])];
}
